/**
 * Pact Door's door look (DJ decision D24, plan 04a §4.1): a door frame of
 * fel fire at each end of the step, whose leaf swings open, stands open and
 * swings shut. Drawn once per pooled door (PactDoorVFXHandler) and animated
 * by alpha/scale only. Palette doctrine: WarlockVFX (fel green, shadow
 * purple, demon ember lantern, pact crimson). Original look, not borrowed.
 */
export const PACT_DOOR_LOOK = {
  /** Outer frame width/height (px); the door stands on the warlock's feet. */
  width: 48,
  height: 80,
  /** Post and lintel thickness (px). */
  post: 6,
  lintel: 7,
  colors: {
    fel: 0x66ff44,
    felDeep: 0x1f6b14,
    voidTop: 0x14051e,
    voidBottom: 0x551188,
    leaf: 0x3a0f2e,
    leafPanel: 0x551188,
    rune: 0x66ff44,
    ember: 0xcc3311,
    emberCore: 0xffb347,
    crimson: 0xb3122e,
  },
  /** Draw depths: halo < void < leaf < frame < lantern. */
  depth: { halo: 91, void: 92, leaf: 93, frame: 94, lantern: 96 },
  /** Frame rising out of the ground (ms) — also how long the void takes to open. */
  riseMs: 140,
  /** Leaf swing open / shut (ms). */
  swingOpenMs: 260,
  swingShutMs: 180,
  /** Leaf scaleX when standing open: past edge-on, so it shows its back. */
  openLeafScale: -0.32,
  /** Fade-out after the leaf shuts (ms). */
  fadeMs: 240,
  /** Lantern flicker half-period (ms) and low alpha. */
  flickerMs: 380,
  flickerAlpha: 0.55,
  /** The far door (where the warlock steps out) stands this long before shutting (ms). */
  exitHoldMs: 420,
  /** Doors kept for reuse; a busier moment closes the oldest. */
  poolSize: 4,
} as const;
